import { Directive, inject } from '@angular/core';
import { PortalTypes } from '@shared/enums';
import { AuthNavigationService } from '@domains/auth/auth-navigation.service';

@Directive({
  selector: '[appGoToAccessPage]',
  standalone: true,
  host: {
    '(click)': 'goToAccess()',
  },
})
export class GoToAccessPageDirective {
  private readonly _authNavigationService = inject(AuthNavigationService);

  protected goToAccess(): void {
    this._authNavigationService.goToAccessPage({
      portalType: PortalTypes.PUBLIC,
    });
  }
}
